import React from 'react';

import { Link } from 'gatsby';

import WhiteLogo from 'assets/tastyfxlogo-white.inline.svg';
import BlackLogo from 'assets/tastyfxlogo.inline.svg';

export enum HeaderLogoVariant {
  WHITE = 'white',
  BLACK = 'black',
}

interface HeaderLogoProps {
  variant?: HeaderLogoVariant;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ variant = HeaderLogoVariant.BLACK }) => {
  return (
    <Link aria-label='Tastyfx Logo' to='/'>
      {variant === HeaderLogoVariant.WHITE ? (
        <WhiteLogo aria-hidden='true' data-testid='white-logo' />
      ) : (
        <BlackLogo aria-hidden='true' data-testid='black-logo' />
      )}
    </Link>
  );
};

export default HeaderLogo;
